module.exports = __webpack_public_path__ + "img/V44.1823dcbd.jpg";